import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import $api from "../api/$api";
import {
  TDataToken,
  TUserAuthStatusParams,
  TUserAuthStatusResponse
} from "./types";

export const getUserAuthStatus = (
  data: TDataToken,
  params: TUserAuthStatusParams
): Promise<TUserAuthStatusResponse> => {
  const { userId, teamId } = params;

  return $api.get(`/users/${userId}/teams/${teamId}/auth`, {
    // @ts-ignore
    token: data.accessToken
  });
};

export const useUserAuthStatus = (
  data: TDataToken,
  queries: TUserAuthStatusParams,
  config?: UseQueryOptions<TUserAuthStatusResponse>
) => {
  return useQuery({
    queryKey: ["user-auth-status", queries],
    queryFn: () => getUserAuthStatus(data, queries),
    ...config
  });
};
